export default (buttons?: any[]) => {
    if (buttons && buttons.length > 0) {
        const modalButton = buttons?.find(x => x.content._contentType === "modalButton");
        const anchorButton = buttons?.find(x => x.content._contentType === "anchorButton");

        if (modalButton) {
            return modalButton;
        }
        else if (anchorButton) {
            return anchorButton;
        }

        return undefined;
    }
};